var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeSheriff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.667,
    height: 16,
    viewBox: "0 0 14.667 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "badge-sheriff",
    d: "M9.667,8A1.333,1.333,0,1,1,8.333,6.666,1.335,1.335,0,0,1,9.667,8Zm6,3.333A1.329,1.329,0,0,1,13.185,12h-2.1a.814.814,0,0,0-.707.411L9.48,14a1.314,1.314,0,0,1,.187.669,1.333,1.333,0,0,1-2.667,0A1.32,1.32,0,0,1,7.187,14l-.9-1.587A.813.813,0,0,0,5.579,12h-2.1a1.336,1.336,0,1,1-.856-1.965L3.553,8.4a.816.816,0,0,0,0-.8L2.625,5.964A1.316,1.316,0,0,1,2.333,6,1.333,1.333,0,1,1,3.481,4h2.1a.813.813,0,0,0,.707-.411L7.187,2A1.321,1.321,0,0,1,7,1.332,1.333,1.333,0,1,1,9.48,2l.9,1.586A.813.813,0,0,0,11.087,4h2.1a1.336,1.336,0,1,1,.856,1.965L13.114,7.6a.818.818,0,0,0,0,.8l.927,1.633A1.316,1.316,0,0,1,14.333,10a1.335,1.335,0,0,1,1.333,1.333ZM11,8a2.667,2.667,0,1,0-2.667,2.667A2.669,2.669,0,0,0,11,8Z",
    transform: "translate(-1 0.001)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeSheriff);
export default __webpack_public_path__ + "static/media/badge-sheriff.3d089f9e1c693a2bb281f1fb6f2766b6.svg";
export { ForwardRef as ReactComponent };